<template>
  <a-modal title="添加原料" :visible="hidden" @ok="ok" :bodyStyle="{ padding: '10px' }" :destroyOnClose="true"
    :forceRender="true" @cancel="cancel" width="900px">
    <a-row style="padding:0 0 15px" type="flex" align="middle" justify="space-between">
      <a-col>
        <a-input-search size="small" v-model="filterData.name" @change="e => inputChange(e, 'name')"
          placeholder="原料名称/代码" style="width: 180px;margin-right: 10px;" allowClear
          @search="e => onSearch(e, 'name')" />
        <a-input-search v-if="overseasFlag == 1" size="small" v-model="filterData.aliasName"
          @change="e => inputChange(e, 'aliasName')" placeholder="原料别名" style="width: 180px"
          @search="e => onSearch(e, 'aliasName')" />
      </a-col>
      <base-list-select style="width:300px" :value="rawType" @change="typeChange" placeholder="选择原料类型" category="raw" />
    </a-row>
    <a-table :columns="columns" :scroll="{ x: 870, y: 450 }" :row-selection="rowSelection" :loading="nutLoading"
      :data-source="list.records" :row-key="record => record.id" :pagination="pagination" @change="listChange">

      <template slot="name" slot-scope="text,record">
        {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
      </template>

      <template slot="fixed3" slot-scope="t">{{ t || t === 0 ? Number(t).toFixed(3) : t }}</template>

      <template slot="rawTypeName" slot-scope="text, record, index">
        <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
          <template slot="title">
            {{ record.fullTypeName }}
          </template>
          <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
        </a-tooltip>
      </template>

      <div slot="status" slot-scope="text, record">
        <span :style="{ color: !text ? 'green' : 'red' }">{{
          !text ? "激活" : "失效"
          }}</span>/{{ record.categoryTypeName ? record.categoryTypeName : "-" }}
      </div>

      <template slot="turnoverDayTitle">
        <label>可耗用天数</label>
        <a-tooltip style="position: relative;top: 1px;margin-left: 4px">
          <template slot="title">期末库存量/近30日平均耗用量</template>
          <a-icon type="exclamation-circle" />
        </a-tooltip>
      </template>

      <template slot="turnoverDay" slot-scope="text, record">
        <a-tooltip v-if="turnoverDayTip(record)" style="margin-right: 4px;">
          <template slot="title">
            高库存原料：{{ record.purchaseClass + ' > ' + (record.purchaseClassCode === '1001' ? '15' : '30') }}天
          </template>
          <a-icon type="info-circle" style="color: orange;" />
        </a-tooltip>
        <label :style="{ color: turnoverDayTip(record) ? 'orange' : '' }">{{ text }}</label>
      </template>

    </a-table>
    <div style="position: absolute;bottom: 10px;left: 10px;">已选中<span style="color: red;">{{ selectedRowKeys.length
        }}</span>个原料</div>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils';
import BaseListSelect from '../select/BaseListSelect.vue';
export default {
  components: { BaseListSelect },
  props: ['hidden'],
  mixins: [nhfMixins],
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading: false,
      filterData: {},
      list: {},
      showFooter: false,
      rawType: [],
      columns: [
        {
          dataIndex: 'name',
          title: '原料名称',
          // width: 300,
          scopedSlots: { customRender: 'name' },
        },
        {
          dataIndex: 'code',
          align: 'center',
          title: '代码',
          width: 110
        },
        {
          dataIndex: 'rawTypeName',
          title: '类型',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'rawTypeName' },
        },
        {
          dataIndex: 'storageWeight',
          title: '库存量',
          width: 120,
          scopedSlots: { customRender: 'fixed3' },
          align: 'center',
        },
        {
          dataIndex: 'unit',
          title: '单位',
          align: 'center',
          width: 80,
        },
        {
          // title: "可耗用天数",
          dataIndex: "turnoverDay",
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { title: 'turnoverDayTitle', customRender: "turnoverDay" },
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'status' }
        },
      ]
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChangeControl,
        getCheckboxProps: record => {
          return ({
            props: {
              disabled: this.selectedRowKeys.length >= 20 && !this.selectedRowKeys.includes(record.id)
            },
          });
        },
      };
    },
  },
  watch: {
    hidden(val) {
      if (val) {
        this.filterData = {};
        this.rawType = [];
        this.$nextTick(() => {
          let { current = 1, pageSize = 100 } = this.pagination || {};
          this.getList({ current, size: pageSize });
        });
      }
    }
  },
  methods: {
    onSelectChangeControl(selectedRowKeys, selectedRows) {
      selectedRowKeys = selectedRowKeys.filter((v, i) => i < this.maxLen);
      this.selectedRowKeys = selectedRowKeys;
      let arr = [...this.selectedRows, ...selectedRows];
      this.selectedRows = selectedRowKeys.map((i) => {
        return arr.filter((item) => item.id === i)[0];
      });
      this.list.records = [...this.list.records];
    },
    inputChange({ target }, feild) {
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ [feild]: target.value, current, size: pageSize });
    },
    ok() {
      if (this.selectedRows.length) {
        this.filterData = {};
        this.$emit('ok', this.selectedRows);
        this.cleanSelect();
        let { current = 1, pageSize = 100 } = this.pagination || {};
        this.getList({ current, size: pageSize });
      } else {
        this.$message.warn('选择需要添加的原料');
      }
    },

    cancel() {
      this.filterData = {};
      this.cleanSelect();
      this.$emit('cancel');
    },

    getList(arg = {}) {
      return this.fetchGet({
        actions: this.mixAddRawPage,
        isList: true,
        name: 'list',
        loading: 'nutLoading',
        data: {
          ...this.filterData,
          factoryId: this.factoryId,
          formulaId: this.formulaId,
          ...arg,
        }
      });
    },

    onSearch(name, feild) {
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ [feild]: name, current, size: pageSize });
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      this.pagination.current = 1;
      let { current = 1, pageSize = 100 } = this.pagination || {};
      this.getList({ typeId, current, size: pageSize });
    },

    listChange(page) {
      this.getList({ ...this.tablePageChange(page), ...this.filterData });
    },

    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },

    turnoverDayTip(record) {
      //purchaseClassCode 1001: 大料，其余为小料
      if ((record.purchaseClassCode === '1001' && record.turnoverDay > 15)
        || (record.purchaseClassCode !== '1001' && record.turnoverDay > 30)) {
        return true;
      }
    },
  }
};
</script>
